


<template>
  <div>
    <!-- BEGIN page-header -->
    <h1 class="page-header">Топ пользователей: <small></small></h1>
    <!-- END page-header -->

    <!-- BEGIN row -->
    <div class="row">
      <!-- BEGIN col-6 -->
      <div class="col-xl-12">
        <!-- BEGIN nav-tabs -->
        <b-tabs nav-wrapper-class="nav nav-tabs" content-class="panel mb-0 p-3 rounded-0">
          <!-- BEGIN tab -->
          <b-tab active @click="fetchData('rating')">
            <template slot="title">
              <span class="d-sm-none">По рейтингу</span>
              <span class="d-sm-block d-none">По рейтингу</span>
            </template>
            <p>Это общий топ по рейтингу исполнителей</p>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th width="50">
                    <h5></h5>
                  </th>
                  <th>
                    <h5>Пользователь</h5>
                  </th>
                  <th width="100">
                    <h5>Рейтинг </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" v-bind:key="user.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <img style="border-radius: 40px;" class="me-2" :src="`/images/avatar/` + user.avatar" alt=""
                      width="40" height="40" />
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.rating }}
                  </td>
                </tr>
                <tr v-if="!users.length">
                  <td colspan="3" align="center"> Нет данных </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <!-- END tab -->
          <!-- BEGIN tab -->
          <b-tab @click="fetchData('all')">
            <template slot="title">
              <span class="d-sm-none">Общий</span>
              <span class="d-sm-block d-none">Общий</span>
            </template>
            <p>Это общий топ кто сколько заработал за все время</p>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th width="50">
                    <h5></h5>
                  </th>
                  <th>
                    <h5>Пользователь</h5>
                  </th>
                  <th width="100">
                    <h5>Заработал </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" v-bind:key="user.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <img style="border-radius: 40px;" class="me-2" :src="`/images/avatar/` + user.avatar" alt=""
                      width="40" height="40" />
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.balance }} руб.
                  </td>
                </tr>
                <tr v-if="!users.length">
                  <td colspan="3" align="center"> Нет данных </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <!-- END tab -->
          <!-- BEGIN tab -->
          <b-tab @click="fetchData('week')">
            <template slot="title">
              <span class="d-sm-none">Сегодня</span>
              <span class="d-sm-block d-none">Сегодня</span>
            </template>
            <p>Это общий топ кто сколько заработал за сегодня</p>
            <table class="table table-hover">

              <thead>
                <tr>
                  <th width="50">
                    <h5></h5>
                  </th>
                  <th>
                    <h5>Пользователь</h5>
                  </th>
                  <th width="100">
                    <h5>Заработал </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" v-bind:key="user.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <img style="border-radius: 40px;" class="me-2" :src="`/images/avatar/` + user.avatar" alt=""
                      width="40" height="40" />
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.balance }} руб.
                  </td>
                </tr>
                <tr v-if="!users.length">
                  <td colspan="3" align="center"> Нет данных </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <!-- END tab -->
          <!-- BEGIN tab -->
          <b-tab @click="fetchData('ref')">
            <template slot="title">
              <span class="d-sm-none">По рефералам</span>
              <span class="d-sm-block d-none">По рефералам</span>
            </template>
            <p>Это общий топ кто сколько заработал на рефералах</p>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th width="50">
                    <h5></h5>
                  </th>
                  <th>
                    <h5>Пользователь</h5>
                  </th>
                  <th width="100">
                    <h5>Заработал </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" v-bind:key="user.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <img style="border-radius: 40px;" class="me-2" :src="`/images/avatar/` + user.avatar" alt=""
                      width="40" height="40" />
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.balance }} руб.
                  </td>
                </tr>
                <tr v-if="!users.length">
                  <td colspan="3" align="center"> Нет данных </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <!-- END tab -->
          <!-- BEGIN tab -->
          <b-tab @click="fetchData('used')">
            <template slot="title">
              <span class="d-sm-none">По рекламодателям</span>
              <span class="d-sm-block d-none">По рекламодателям</span>
            </template>
            <p>Это общий топ кто сколько потратил на заданиях</p>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th width="50">
                    <h5></h5>
                  </th>
                  <th>
                    <h5>Пользователь</h5>
                  </th>
                  <th width="100">
                    <h5>Потратил </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" v-bind:key="user.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <img style="border-radius: 40px;" class="me-2" :src="`/images/avatar/` + user.avatar" alt=""
                      width="40" height="40" />
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.balance }} руб.
                  </td>
                </tr>
                <tr v-if="!users.length">
                  <td colspan="3" align="center"> Нет данных </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <!-- END tab -->
          <!-- BEGIN tab -->
          <b-tab @click="fetchData('used_week')">
            <template slot="title">
              <span class="d-sm-none">По рекламодателям(месяц)</span>
              <span class="d-sm-block d-none">По рекламодателям(месяц)</span>
            </template>
            <p>Это общий топ кто сколько потратил на заданиях за месяц</p>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th width="50">
                    <h5></h5>
                  </th>
                  <th>
                    <h5>Пользователь</h5>
                  </th>
                  <th width="100">
                    <h5>Потратил </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" v-bind:key="user.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <img style="border-radius: 40px;" class="me-2" :src="`/images/avatar/` + user.avatar" alt=""
                      width="40" height="40" />
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.balance }} руб.
                  </td>
                </tr>
                <tr v-if="!users.length">
                  <td colspan="3" align="center"> Нет данных </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <!-- END tab -->
        </b-tabs>
        <!-- END hljs-wrapper -->
      </div>
      <!-- END col-6 -->

    </div>
    <!-- END row -->


  </div>
</template>


<script>
import HTTP from "../http";
import {show_error} from "../message";

export default {

  data() {
    return {
      loading: false,
      errors: null,
      users: []
    };
  },

  created() {
    this.fetchData('rating')
  },

  methods: {

    fetchData(type) {
      this.loading = true;
      this.$insProgress.start();

      HTTP()
        .get(`/top?${type}`)
        .then((resp) => {
          console.log('resp', resp)
          this.users = resp.data;
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },

  }
}

</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}
</style>

